import apiService from '@/utils/request';
import { parseURI, objectToQueryString } from '@/utils';

const URIs = {
  vigenciaCuotaEmpresa: '/v1/empresas/{0}/cuotas/{1}/vigencia',
  exencionesEmpresa: '/v1/empresas/{0}/exencionesCuotas/',
  vigenciaBaseCotizacionEmpresa: '/v1/empresas/{0}/cuotas/{1}/basesCotizacion/{2}/vigencia/{3}',
  reduccionEmpresa: '/v1/empresas/{0}/reduccionesBaseCotizacion/{1}-{2}',
  impuestoCuota: '/v1/empresas/{0}/cuotas/{1}/impuesto'
};

export function getVigenciaCuotaEmpresa({ idEmpresa, idCuota }) {
  let uri = parseURI(URIs.vigenciaCuotaEmpresa, idEmpresa, idCuota);
  return apiService.get(uri);
}

export function getExencionesEmpresa({ idEmpresa, idCuota }) {
  let uri = parseURI(URIs.exencionesEmpresa, idEmpresa);
  uri += objectToQueryString({ idCuota });
  return apiService.get(uri);
}

export function getVigenciaBaseCotizacionEmpresa({
  id,
  idEmpresa,
  idCuota,
  idBaseCotizacion,
  fechaConsumo
}) {
  let uri = parseURI(URIs.vigenciaBaseCotizacionEmpresa, idEmpresa, idCuota, idBaseCotizacion, id);
  uri += objectToQueryString({ fechaConsumo });
  return apiService.get(uri);
}

export function getImpuestoCuota({ idEmpresa, idCuota }) {
  let uri = parseURI(URIs.impuestoCuota, idEmpresa, idCuota);
  return apiService.get(uri);
}
